// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();

(function () {
    jQuery(document).ready(function ($) {
        $(window).scroll(function () {
            if (($(window).scrollTop() > 50 && !$('.navbar').hasClass('navbar--scroll')) || ($(window).scrollTop() === 0 && $('.navbar').hasClass('navbar--scroll'))) {
                $('.navbar').toggleClass('navbar--scroll');
            }
        });
        $('.navbar-nav>li>a').on('click', function () {
            $('.navbar-collapse').collapse('hide');
        });

        $('a[href^="#"]').bind('click', function (e) {
            event.preventDefault();
            var target = $(this).attr('href');
            var scrollToPosition = $(target).offset().top - 100;
            window.scroll({
                top: scrollToPosition,
                left: 0,
                behavior: 'smooth',
            });
        });

        $('.navbar-collapse').on('show.bs.collapse', function () {
            $('.navbar').addClass('navbar--open');
        });

        $('.navbar-collapse').on('hide.bs.collapse', function () {
            $('.navbar').removeClass('navbar--open');
        });

        $('.page-header').slick({
            arrows: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: false,
            fade: true,
            cssEase: 'linear',
        });
        $('.slider_clients').slick({
            slidesToShow: 1,
            mobileFirst: true,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '50px',
            prevArrow: $('.btn-slider-left'),
            nextArrow: $('.btn-slider-right'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '30px',
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        centerMode: false,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        centerMode: false,
                        slidesToShow: 6,
                    },
                },
            ],
        });
    });
})();
